export const dumpCreateOrder = (data) => {
  const { personal_fields, details_of_the_currency_being_given, details_of_the_currency_received } =
    data;

  const givenFields = details_of_the_currency_being_given?.map((item) => ({
    field: item?.field_name,
    name: item?.name,
  }));

  const paymentFields = details_of_the_currency_received?.map((item) => ({
    field: item?.field_name,
    name: item?.name,
  }));

  const personalFields = personal_fields?.map((item) => ({
    field: item?.field_name,
    name: item?.name,
  }));

  delete data?.payment_fields;
  delete data?.personal_fields;
  delete data?.details_of_the_currency_being_given;
  delete data?.details_of_the_currency_received;

  return { ...data, fields: [...givenFields, ...paymentFields, ...personalFields] };
};

export const dumpAcceptOrder = (data) => {
  const { personal_fields, details_of_the_currency_being_given, details_of_the_currency_received } =
    data;

  const givenFields = details_of_the_currency_being_given?.map((item) => ({
    field: item?.field_name,
    name: item?.name,
    translate: item?.field_translate,
  }));

  const paymentFields = details_of_the_currency_received?.map((item) => ({
    field: item?.field_name,
    name: item?.name,
    translate: item?.field_translate,
  }));

  const personalFields = personal_fields?.map((item) => ({
    field: item?.field_name,
    name: item?.name,
    translate: item?.field_translate,
  }));

  delete data?.details_of_the_currency_being_given;
  delete data?.details_of_the_currency_received;
  delete data?.payment_fields;
  delete data?.personal_fields;

  return { ...data, fields: [...givenFields, ...paymentFields, ...personalFields] };
};
